import React from "react";

import {UploadOutlined} from "@ant-design/icons";
import {Button, Form, Input, InputNumber, message, Select, Upload} from "antd";
import {DatePicker} from "antd";
import TextArea from "antd/es/input/TextArea";
import dayjs from "dayjs";
import advancedFormat from "dayjs/plugin/advancedFormat";
import customParseFormat from "dayjs/plugin/customParseFormat";
import localeData from "dayjs/plugin/localeData";
import weekday from "dayjs/plugin/weekday";
import weekOfYear from "dayjs/plugin/weekOfYear";
import weekYear from "dayjs/plugin/weekYear";

import SuggestAutoComplete from "./SuggestAutoComplete";
import SuggestSelect from "./SuggestSelect";

dayjs.extend(customParseFormat);
dayjs.extend(advancedFormat);
dayjs.extend(weekday);
dayjs.extend(localeData);
dayjs.extend(weekOfYear);
dayjs.extend(weekYear);
const {Option} = Select;


export const filterOptionByLabel = (input, option) =>
	(option?.label ?? "").toString().toLowerCase().includes(input.toString().toLowerCase());

export function StandardForm({form, fields, onFinish, initialValues, onFieldsChange, otherProps}) {
	const getInputByType = item => {
		const commonProps = {...item.props};
		const props = {
			action: item.action,
			headers: item.headers,
			beforeUpload: file => {
				const isExcel = file.type === "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";
				if (!isExcel) {
					message.error(`${file.name} is not an Excel file`);
				}
				return isExcel || Upload.LIST_IGNORE;
			},
		};

		switch (item._type) {
			case "number":
				return <InputNumber style={{width: "50%"}} min={item.min} max={item.max} {...commonProps} />;
			case "file":
				return (
					<Upload {...props}>
						<Button icon={<UploadOutlined />}>Upload Excel files only</Button>
					</Upload>
				);
			case "date":
				return <DatePicker format="YYYY-MM-DD" {...commonProps} />;
			case "long_text":
				return <TextArea {...commonProps} />;
			case "select":
				return (
					<Select placeholder="Select an option" allowClear {...commonProps}>
						{item.options.map((opt, key) => (
							<Option key={key} value={opt}>
								{opt}
							</Option>
						))}
					</Select>
				);
			case "select-object":
				return (
					<Select placeholder="Select an option" allowClear options={item.options} {...commonProps}></Select>
				);
			case "select-tag":
				return (
					<SuggestSelect placeholder="Select an option" options={item.options} allowClear {...commonProps} />
				);
			case "autocomplete":
				return <SuggestAutoComplete options={item.options} placeholder="Select value" {...commonProps} />;
			default:
				return <Input {...commonProps} />;
		}
	};

	return (
		<Form
			requiredMark={false}
			onFieldsChange={onFieldsChange}
			onFinish={onFinish}
			form={form}
			initialValues={{...initialValues}}
			{...otherProps}
			id="editForm">
			{fields.map((v, i) => (
				<Form.Item
					key={i}
					label={v.label ? <b>{v.label}</b> : null}
					name={v.name}
					rules={[
						...(v.required
							? [
									{
										required: true,
										message: v.message || "Required",
									},
								]
							: []),
						...(v.rules || []),
					]}
					dependencies={v.dependencies}>
					{getInputByType(v)}
				</Form.Item>
			))}
		</Form>
	);
}
